module.exports = __webpack_public_path__ + "static/media/stofferingen-13.66aeaf78.jpg";